import { useMemo } from 'react'
import { useRootStore } from 'stores/RootStore'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

export type AddOnDisplayItem = {
  key: PaymentPlanKey.BlazeAutopilotExtraAccounts | PaymentPlanKey.BlazeAutopilotWhiteLabel
  name: string
  monthlyPriceTotal: number
  price: number
  tooltip: string | null
  monthlyPriceForSingleAccount: number
}

export const useAddOnDisplayItems = (): AddOnDisplayItem[] => {
  const { currentSubscription } = useRootStore().tierUsageStore

  return useMemo(() => {
    if (!currentSubscription?.subscription_items) return []

    const items: AddOnDisplayItem[] = []

    const extraAccountItem = currentSubscription.subscription_items.find(
      (item: any) => item.plan_key === PaymentPlanKey.BlazeAutopilotExtraAccounts,
    )
    if (extraAccountItem) {
      const price = currentSubscription.prices?.find((p: StripePrice) => p.id === extraAccountItem.price_id)
      const totalAccounts = extraAccountItem.quantity
      const monthlyPrice = price ? price.unit_amount / price.recurring.interval_count / 100 : 0
      if (monthlyPrice > 0) {
        items.push({
          key: PaymentPlanKey.BlazeAutopilotExtraAccounts,
          name: `${totalAccounts} extra account${totalAccounts === 1 ? '' : 's'}`,
          monthlyPriceTotal: monthlyPrice * totalAccounts,
          price: price ? (price.unit_amount / 100) * totalAccounts : 0,
          tooltip: 'Additional posting accounts to increase your online presence.',
          monthlyPriceForSingleAccount: monthlyPrice,
        })
      }
    }

    const whiteLabelItem = currentSubscription.subscription_items.find(
      (item: any) => item.plan_key === PaymentPlanKey.BlazeAutopilotWhiteLabel,
    )
    if (whiteLabelItem) {
      const price = currentSubscription.prices?.find((p: StripePrice) => p.id === whiteLabelItem.price_id)
      const monthlyPriceTotal = price ? price.unit_amount / price.recurring.interval_count / 100 : 0
      if (monthlyPriceTotal > 0) {
        items.push({
          key: PaymentPlanKey.BlazeAutopilotWhiteLabel,
          name: 'White Label',
          monthlyPriceTotal,
          price: price ? price.unit_amount / 100 : 0,
          tooltip: 'Change the visual identity of your workspace with your logo and colors.',
          monthlyPriceForSingleAccount: monthlyPriceTotal,
        })
      }
    }

    return items
  }, [currentSubscription])
}
